import React, { useState, Fragment, useEffect } from 'react';
import {
  Carousel, OptionButton, BottomNav, StatGraph,
} from 'components';
import { injectIntl, FormattedMessage } from 'react-intl';
import { delayTime } from 'shared/constants';
import './RiskPicker.scss';
import arrow from 'assets/icons/next.svg';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { updateSummary } from 'shared/redux/actions';

const RiskPicker = ({
  onSubmit,
  optionList,
  intl,
  rtl,
  onUpdateSummary,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const classes = classNames({
    'nw-risk-picker': true,
    'nw-risk-picker--rtl': rtl,
  });

  useEffect(() => {
    onUpdateSummary({
      'summary.allRisks': optionList,
    });
  }, [onUpdateSummary, optionList]);

  return (
    optionList && optionList.length && (
    <Fragment>
      <Carousel rtl={rtl} initialSlide={2} isCenterMode variableWidth className={classes}>
        {optionList && optionList.map(item => (
          <div key={item.preRiskProfileCode}>
            <div className="nw-risk-option">
              <h5>{intl.formatMessage({ id: item.riskProfileCode })}</h5>

              <StatGraph
                loss={item.predictedLoss * -1}
                gain={item.predictedGain}
                lossLabel="risk.worstYear"
                gainLabel="risk.bestYear"
              />
              {/* <div className="nw-risk-option__stat">
                <span className="nw-risk-option__stat--worst">{item.predictedLoss}</span>
                <div className="nw-risk-option__stat-block">
                  <div className="nw-risk-option__stat-block--worst" style={{ width: `${item.predictedLoss * -1}%` }} />
                  <div className="nw-risk-option__stat-block--best" style={{ width: `${item.predictedGain}%` }} />
                </div>
                <span className="nw-risk-option__stat--best">{item.predictedGain}</span>
              </div>
              <div className="nw-risk-option__stat-desc">
                <FormattedMessage id="risk.worstYear" />
                <FormattedMessage id="risk.bestYear" />
              </div> */}
              {Array.isArray(item.preRiskProfileDescription) && item.preRiskProfileDescription ? (
                <ul>
                  {item.preRiskProfileDescription.map((i, idx) => (
                    <li key={idx}>{i}</li>
                  ))}
                </ul>
              )
                : <p>{intl.formatMessage({ id: item.preRiskProfileDescription })}</p>
                  }
              <OptionButton
                label={intl.formatMessage({ id: 'risk.chooseRisk' }, { risk: intl.formatMessage({ id: item.riskProfileCode }) })}
                onOptionClick={() => {
                  setSelectedOption(item.preRiskProfileCode);
                  setTimeout(() => onSubmit(item.preRiskProfileCode), delayTime);
                }}
                id={item.preRiskProfileCode}
                name="risk-picker"
                selected={selectedOption}
              />
            </div>
          </div>
        ))}
      </Carousel>
      <BottomNav
        rtl={rtl}
        rightButton={(
          <>
            <FormattedMessage id="risk.notSure" />
            <span className="arrow"><img src={arrow} alt="Icon arrow next" /></span>
          </>
        )}
        onRightClick={() => onSubmit('not_sure')}
      />
    </Fragment>
    )
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = ({
  onUpdateSummary: updateSummary,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RiskPicker));
